import { RENEWAL_ENDPOINTS, Renewal, RenewalSubmit } from '@iws/backoffice-api'

import { Model } from '@/clients/http'

export type { Renewal }

type ErrorBody = { message?: string }

export class RenewalModel extends Model {
  public static readonly correlations = {
    GET_LIST: 'GET_RENEWAL_LIST',
    PROOF_UPLOAD_URL: 'GET_RENEWAL_PROOF_UPLOAD_URL',
    SUBMIT: 'SUBMIT_RENEWAL',
  }

  /** This business's requests and its current expiry. */
  public static readonly getList = async () =>
    this.createHttpRequest<{ result: Renewal[]; expiration_date: string | null }, ErrorBody>({
      correlationKey: this.correlations.GET_LIST,
      payload: { method: 'get', url: this.createEndpoint({ url: RENEWAL_ENDPOINTS.list }), useBearerToken: true },
    })

  public static readonly getProofUploadUrl = async (body: { file_name: string; content_type: string }) =>
    this.createHttpRequest<{ result: { upload_url: string; path: string } }, ErrorBody>({
      correlationKey: this.correlations.PROOF_UPLOAD_URL,
      payload: { method: 'post', url: this.createEndpoint({ url: RENEWAL_ENDPOINTS.proofUploadUrl }), body, useBearerToken: true },
    })

  public static readonly submit = async (body: RenewalSubmit) =>
    this.createHttpRequest<{ result: Renewal }, ErrorBody>({
      correlationKey: this.correlations.SUBMIT,
      payload: { method: 'post', url: this.createEndpoint({ url: RENEWAL_ENDPOINTS.submit }), body, useBearerToken: true },
    })
}
